
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 16.59C0 17.367.633 18 1.41 18h21.18c.777 0 1.41-.633 1.41-1.41V4.19 1.41C24 .633 23.367 0 22.59 0H1.41C.633 0 0 .633 0 1.41v15.18zM22.5 3.719V1.5h-21v2.219l10.154 5.256a.748.748 0 00.693 0L22.5 3.72zm0 1.69l-9.464 4.899a2.258 2.258 0 01-2.072 0L1.5 5.407V16.5h21V5.409z","fill":"currentColor"}})])
          )
        }
      }
    